import Vue from 'vue';
import { SPARK_TOKEN } from './actions.type';
import CryptoJS from 'crypto-js';

const SALT = "dy1wxyw30izgan3136uygqmd4vv3lxw8_radica1_01xAV6_HS";
const KEY = "2SeocE4Dqt3mVFucBwL/LRGhHPkq+NspsqNv27V1xpE=";

const headers = {
  'Content-Type': 'application/json',
  "locale": "en_US",
  'channelKey': 'ks89KxrQCeKbe5R/cFMulvDJWdVDxvTpr1nVfSX2ECUu4P7NQMaRZeNGlelWT9ic',
  'channelCode': 'Ticketbox',
  'tenantCode': 'arttha',
  'checkSum': 'Ticketbox',
  'Access-Control-Allow-Origin': '*'
};

const SPARK_API_URL = 'https://spark-dev-core.absabank.mu/api/v1';

const state = {
  spark: JSON.parse(localStorage.getItem('spark')) || false
};

const getters = {
  isSpark: (state) => state.spark,
};

const actions = {
  async [SPARK_TOKEN](context, params) {
    headers["requestID"] = params.orderId;
     // const ipResponse = await fetch('https://api64.ipify.org?format=json');
      // const ipData = await ipResponse.json();
      // const ipAddress = ipData.ip;
      // headers["ip"] = ipAddress;
    // Convert params to string and remove spaces
    let paramString = JSON.stringify(params).replace(/\s/g, '');

    // Create checksum
    const checkSum = createChecksum(paramString, SALT, KEY);
    
    // Add checksum to headers
    headers["checkSum"] = checkSum;

    try {
      const response = await Vue.axios.post(`${SPARK_API_URL}/transactionRequest/create/token`, params, { headers });
      return response;
    } catch (error) {
      throw error;
    }
  },
  updateSpark({ commit }, value) {
    commit('setSpark', value);
  }
};

const mutations = {
  setSpark(state, value) {
    state.spark = value;
    localStorage.setItem('spark', JSON.stringify(value));
  }
};

// Function to create checksum
function createChecksum(str, salt, key) {
  // Hash the string with SHA-256
  const saltedString = salt + str;
  const hash = CryptoJS.SHA256(saltedString).toString(CryptoJS.enc.Base64);

  // Encrypt the hash string with AES-256
  const keyForAES = CryptoJS.enc.Base64.parse(key);
  const encrypted = CryptoJS.AES.encrypt(hash, keyForAES, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

export default {
  state,
  getters,
  actions,
  mutations,
};
